import React, { FC, ReactNode, RefObject } from 'react';
import { styled } from 'linaria/react';
import { TspAutoComplete } from '@features/tsp/autocomplete';
import { TspSuggestionItem, SearchPayee } from '@entities/tsp';
import { convertPxToRem } from '@shared/lib';
import { withTheme } from '@shared/lib/theme';
import { Modal, ModalProps } from '@shared/ui/organisms';
import { Spinner, Text } from '@shared/ui/atoms';
import SearchInputDesktop from './SearchInputDesktop';
import SuggestButton from './SuggestButton';
type SuggestModalProps = ModalProps;
interface SearchModalDesktopProps extends ModalProps {
  navbarRef: RefObject<HTMLElement>;
  servicesForSearch?: SearchPayee[];
  renderSuggestModal: (props: SuggestModalProps) => ReactNode;
}
const SearchModalDesktop: FC<SearchModalDesktopProps> = ({
  navbarRef,
  servicesForSearch,
  renderSuggestModal,
  ...props
}) => {
  const navbarCords = navbarRef.current?.getBoundingClientRect();
  if (!navbarCords) return null;
  return <Modal {...props}>
      <ContentWrapper navbarCords={navbarCords}>
        <TspAutoComplete servicesForSearch={servicesForSearch}>
          {({
          searchTerm,
          onSearchTermChange,
          suggestions,
          isReady
        }) => <>
              <SearchInputWrapper inputHeight={navbarCords.height}>
                <SearchInputDesktop value={searchTerm} onChange={onSearchTermChange} inputHeight={navbarCords.height} handleClose={props.onClose} />
              </SearchInputWrapper>

              {searchTerm && <SuggestionsWrapper>
                  {!isReady ? <SpinnerWrapper>
                      <Spinner />
                    </SpinnerWrapper> : <>
                      {suggestions.length > 0 ? suggestions.map(item => <TspSuggestionItem key={item.providerName} item={item} />) : <TextWrapper>
                          <Text family="MTSCompact" size="pS" weight="medium" color="secondary">
                            По вашему запросу ничего не нашли :(
                          </Text>
                        </TextWrapper>}
                      <SuggestButton renderSuggestModal={renderSuggestModal} />
                    </>}
                </SuggestionsWrapper>}
            </>}
        </TspAutoComplete>
      </ContentWrapper>
    </Modal>;
};
export default SearchModalDesktop;
interface ContentWrapperProps {
  navbarCords: DOMRect;
}
const _exp = /*#__PURE__*/() => ({
  navbarCords
}) => convertPxToRem(navbarCords.top);
const _exp2 = /*#__PURE__*/() => ({
  navbarCords
}) => convertPxToRem(navbarCords.left);
const _exp3 = /*#__PURE__*/() => ({
  navbarCords
}) => convertPxToRem(navbarCords.width);
const ContentWrapper = /*#__PURE__*/styled('div')({
  name: "ContentWrapper",
  class: "c15zg1bz",
  propsAsIs: false,
  vars: {
    "c15zg1bz-0": [_exp(), "rem"],
    "c15zg1bz-1": [_exp2(), "rem"],
    "c15zg1bz-2": [_exp3(), "rem"]
  }
});
interface SearchInputWrapperProps {
  inputHeight: number;
}
const _exp4 = /*#__PURE__*/() => ({
  inputHeight
}) => `${convertPxToRem(inputHeight)}`;
const SearchInputWrapper = /*#__PURE__*/styled('div')({
  name: "SearchInputWrapper",
  class: "s1j3ohff",
  propsAsIs: false,
  vars: {
    "s1j3ohff-0": [_exp4(), "rem"]
  }
});
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.secondary;
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => `1px solid ${theme.colors.stroke.default}`;
const SuggestionsWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "SuggestionsWrapper",
  class: "s1r9ar0z",
  propsAsIs: false,
  vars: {
    "s1r9ar0z-0": [_exp5()],
    "s1r9ar0z-1": [_exp6()]
  }
}));
const TextWrapper = /*#__PURE__*/styled('div')({
  name: "TextWrapper",
  class: "t9yy172",
  propsAsIs: false
});
const SpinnerWrapper = /*#__PURE__*/styled('div')({
  name: "SpinnerWrapper",
  class: "s17nlfho",
  propsAsIs: false
});

require("./SearchModalDesktop.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./SearchModalDesktop.tsx");